(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (form) => {
      if (form.dataset.validationReady === 'true') return;
      form.dataset.validationReady = 'true';
      form.setAttribute('novalidate', '');
      const submit = form.querySelector('[type="submit"]');
      const fields = Array.from(form.querySelectorAll('[required]'));

      const messageFor = (field) => {
        const v = field.validity;
        if (v.valueMissing) return field.dataset.errorRequired || '';
        if (v.typeMismatch) return field.dataset.errorType || '';
        if (v.tooShort) return field.dataset.errorTooshort || '';
        return '';
      };

      const errorEl = (field) => {
        let el = document.getElementById(field.id + '-inline-error');
        if (!el) {
          el = document.createElement('p');
          el.className = 'contact-form__field-error';
          el.id = field.id + '-inline-error';
          el.hidden = true;
          field.insertAdjacentElement('afterend', el);
        }
        return el;
      };

      const render = (field) => {
        const msg = field.dataset.touched === 'true' ? messageFor(field) : '';
        const el = errorEl(field);
        el.textContent = msg;
        el.hidden = msg === '';
        field.setAttribute('aria-invalid', msg ? 'true' : 'false');
        if (msg) field.setAttribute('aria-describedby', el.id);
      };

      const refresh = () => {
        if (submit) submit.disabled = !form.checkValidity();
      };

      fields.forEach((field) => {
        const eventName = field.tagName === 'SELECT' ? 'change' : 'input';
        field.addEventListener(eventName, () => {
          render(field);
          refresh();
        });
        field.addEventListener('blur', () => {
          field.dataset.touched = 'true';
          render(field);
          refresh();
        });
      });

      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          fields.forEach((field) => {
            field.dataset.touched = 'true';
            render(field);
          });
          refresh();
          const firstInvalid = fields.find((field) => !field.validity.valid);
          if (firstInvalid) firstInvalid.focus();
        }
      });

      refresh();
    };

    const setupAll = () => document.querySelectorAll('.contact-form__form').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
